(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["more-from-brand"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('kb-more-from-brand')) {
  customElements.define('kb-more-from-brand', class extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.loadProducts();
    }

    async loadProducts() {
      try {
        const url = new URL(this.dataset.url, window.location.origin);
        url.searchParams.set('section_id', this.dataset.sectionId);
        url.searchParams.set('sort_by', 'best-selling');
        const response = await fetch(url.toString());
        if (!response.ok) throw new Error('Could not load brand products');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (!this.isConnected) return;
        const cardsTemplate = doc.querySelector('template[data-brand-cards]');
        const layoutTemplate = this.querySelector('template[data-brand-layout]');
        if (!cardsTemplate || !layoutTemplate) return;

        const cards = Array.from(cardsTemplate.content.children)
          .filter(card => card.dataset.brandProductId !== this.dataset.productId)
          .slice(0, Number(this.dataset.limit));
        if (!cards.length) return;

        const fragment = layoutTemplate.content.cloneNode(true);
        const slider = fragment.querySelector('product-slider');
        const grid = fragment.querySelector('.products-grid');
        const wrap = fragment.querySelector('.products-grid-wrap');
        slider.dataset.totalItems = String(cards.length);
        cards.forEach(card => grid.appendChild(card));

        const controls = fragment.querySelector('.swiper-controls');
        if (controls) {
          controls.classList.toggle('md:flex', cards.length > Number(slider.dataset.tabletItems));
          controls.classList.toggle('lg:flex', cards.length > Number(slider.dataset.items));
          controls.classList.toggle('lg:hidden', cards.length <= Number(slider.dataset.items));
        }
        if (cards.length <= Number(this.dataset.mobileColumns)) {
          wrap.classList.remove('swipe-mobile', `swipe-mobile--${this.dataset.mobileColumns}-cols`);
          grid.classList.remove('swipe-mobile__inner');
          fragment.querySelector('scroll-progress-bar')?.remove();
        }
        // Make the section visible before the theme's slider measures its width.
        this.hidden = false;
        this.replaceChildren(fragment);
      } catch (error) {
        console.warn('More From Brand:', error);
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["open-box-notification"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kb-open-box-notification')) {
    customElements.define('kb-open-box-notification', class extends HTMLElement {
      connectedCallback() {
        const button = this.querySelector('[data-open-box-close]');
        if (!button || this.closeHandler) return;
        this.closeHandler = () => {
          const wrapper = this.closest('.shopify-section') || this;
          wrapper.style.setProperty('display', 'none', 'important');
        };
        button.style.display = 'inline-flex';
        button.addEventListener('click', this.closeHandler);
      }
      disconnectedCallback() {
        const button = this.querySelector('[data-open-box-close]');
        if (button && this.closeHandler) button.removeEventListener('click', this.closeHandler);
        this.closeHandler = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-thoughts"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kb-our-thoughts')) {
    customElements.define('kb-our-thoughts', class extends HTMLElement {
      connectedCallback() {
        if (!this.hasAttribute('data-collapsible') || this.observer) return;
        this.content = this.querySelector('.kb-our-thoughts__content');
        this.button = this.querySelector('.kb-our-thoughts__toggle');
        this.expanded = false;
        this.onToggle = () => {
          this.expanded = !this.expanded;
          this.update();
        };
        this.onFocus = () => {
          if (this.hasAttribute('data-collapsed')) {
            this.expanded = true;
            this.update();
          }
        };
        this.button.addEventListener('click', this.onToggle);
        this.content.addEventListener('focusin', this.onFocus);
        this.observer = new ResizeObserver(() => this.update());
        this.observer.observe(this.content);
        this.update();
      }
      update() {
        const limit = parseFloat(getComputedStyle(this).getPropertyValue('--thoughts-preview-height'));
        const overflowing = this.content.scrollHeight > limit + 2;
        this.button.hidden = !overflowing;
        this.toggleAttribute('data-collapsed', overflowing && !this.expanded);
        this.button.setAttribute('aria-expanded', String(this.expanded));
        this.button.querySelector('[data-more]').hidden = this.expanded;
        this.button.querySelector('[data-less]').hidden = !this.expanded;
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.observer = null;
        this.button?.removeEventListener('click', this.onToggle);
        this.content?.removeEventListener('focusin', this.onFocus);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-accessories"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cart-product-accessories')) {
  customElements.define('cart-product-accessories', class extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.revision = 0;
      this.onCartChange = () => this.schedule();
      this.onPageShow = (event) => { if (event.persisted) this.schedule(); };
      document.addEventListener('cart:updated', this.onCartChange);
      document.addEventListener('cart:refresh', this.onCartChange);
      window.addEventListener('pageshow', this.onPageShow);
      if ('PerformanceObserver' in window) {
        this.observer = new PerformanceObserver((list) => {
          if (list.getEntries().some((entry) => {
            const url = new URL(entry.name, location.origin);
            return url.origin === location.origin && /\/cart\/(add|change|update|clear)(\.js)?\/?$/.test(url.pathname);
          })) this.schedule();
        });
        this.observer.observe({ entryTypes: ['resource'] });
      }
      this.schedule();
    }

    disconnectedCallback() {
      this.started = false;
      this.revision += 1;
      clearTimeout(this.timer);
      this.controller?.abort();
      this.observer?.disconnect();
      document.removeEventListener('cart:updated', this.onCartChange);
      document.removeEventListener('cart:refresh', this.onCartChange);
      window.removeEventListener('pageshow', this.onPageShow);
    }

    schedule() {
      clearTimeout(this.timer);
      this.controller?.abort();
      const revision = ++this.revision;
      this.timer = setTimeout(() => this.refresh(revision), 200);
    }

    async refresh(revision) {
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const content = this.querySelector('[data-accessory-content]');
      try {
        const cartResponse = await fetch(this.dataset.cartUrl, { signal, cache: 'no-store' });
        if (!cartResponse.ok) throw new Error('Cart unavailable');
        const cart = await cartResponse.json();
        const productIds = [...new Set(cart.items.map((item) => String(item.product_id)))];
        if (revision !== this.revision || !this.isConnected) return;
        if (!productIds.length) {
          this.hidden = true;
          content.replaceChildren();
          this.signature = '';
          return;
        }
        const signature = productIds.join(',');
        if (signature === this.signature && content.children.length) {
          this.hidden = false;
          return;
        }
        this.hidden = true;
        const results = new Array(productIds.length);
        let nextIndex = 0;
        await Promise.all(Array.from({ length: Math.min(4, productIds.length) }, async () => {
          while (nextIndex < productIds.length && !signal.aborted) {
            const index = nextIndex++;
            const url = new URL(this.dataset.recommendationsUrl, location.origin);
            url.searchParams.set('section_id', this.dataset.sectionId);
            url.searchParams.set('product_id', productIds[index]);
            url.searchParams.set('intent', 'complementary');
            url.searchParams.set('limit', '10');
            try {
              const response = await fetch(url, { signal });
              if (!response.ok) throw new Error('Recommendations unavailable');
              const html = new DOMParser().parseFromString(await response.text(), 'text/html');
              results[index] = [...(html.querySelector('template[data-accessory-cards]')?.content.querySelectorAll('[data-accessory-id]') || [])];
            } catch (error) {
              if (signal.aborted) throw error;
              results[index] = [];
            }
          }
        }));
        if (revision !== this.revision || !this.isConnected) return;
        const seen = new Set(productIds);
        const cards = [];
        const limit = Number(this.dataset.limit);
        const depth = Math.max(0, ...results.map((items) => items.length));
        for (let position = 0; position < depth && cards.length < limit; position++) {
          for (const items of results) {
            const card = items[position];
            if (!card || seen.has(card.dataset.accessoryId)) continue;
            seen.add(card.dataset.accessoryId);
            cards.push(card);
            if (cards.length === limit) break;
          }
        }
        this.signature = signature;
        if (!cards.length) {
          content.replaceChildren();
          this.hidden = true;
          return;
        }
        const fragment = this.querySelector('[data-accessory-layout]').content.cloneNode(true);
        const slider = fragment.querySelector('product-slider');
        const grid = fragment.querySelector('.products-grid');
        grid.append(...cards.map((card) => document.importNode(card, true)));
        slider.dataset.totalItems = String(cards.length);
        const controls = fragment.querySelector('.swiper-controls');
        if (controls) {
          controls.classList.toggle('md:flex', cards.length > Number(slider.dataset.tabletItems));
          controls.classList.toggle('lg:flex', cards.length > Number(slider.dataset.items));
          controls.classList.toggle('lg:hidden', cards.length <= Number(slider.dataset.items));
        }
        if (cards.length <= Number(this.dataset.mobileColumns)) {
          const wrap = fragment.querySelector('.products-grid-wrap');
          wrap.classList.remove('swipe-mobile', 'swipe-mobile--1-cols', 'swipe-mobile--2-cols');
          grid.classList.remove('swipe-mobile__inner');
          fragment.querySelector('scroll-progress-bar')?.remove();
        }
        this.hidden = false;
        content.replaceChildren(fragment);
      } catch (error) {
        if (revision === this.revision && !signal.aborted) {
          this.hidden = true;
          this.signature = '';
          content.replaceChildren();
        }
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
